var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"files",staticClass:"d-none",attrs:{"multiple":"","type":"file"},on:{"input":_vm.onUpload}}),_vm._t("activator",null,{"attachFiles":_vm.attachFiles})],2)}
var staticRenderFns = []

export { render, staticRenderFns }